import { Component, inject, OnInit, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'app-navigation',
  imports: [CommonModule],
  template: `
    <!-- Silver rate ticker + sticky nav wrapper -->
    <div class="sticky top-0 z-50">
      <!-- Silver rate ticker -->
      <div class="bg-amber-50 border-b border-amber-100 px-4 py-1.5 flex items-center justify-center gap-2">
        <i class="pi pi-circle-fill text-amber-400 text-[6px]"></i>
        <span class="text-xs font-medium text-amber-800">Silver Rate Today:</span>
        <span class="text-xs font-bold text-amber-600">₹ {{ silverRate | number:'1.0-2' }} / gram</span>
        <i class="pi pi-circle-fill text-amber-400 text-[6px]"></i>
      </div>

      <nav class="bg-white border-b border-gray-100 shadow-sm">
        <div class="flex items-center h-14 px-4 sm:px-6">

          <!-- Hamburger: only visible when sidebar is closed -->
          @if (!navOpen()) {
            <button (click)="menuToggle.emit()" title="Open menu"
              class="w-9 h-9 mr-2 rounded-lg flex items-center justify-center text-gray-600 hover:bg-gray-100 flex-shrink-0">
              <i class="pi pi-bars text-base"></i>
            </button>
          }

          <!-- Profile (right) -->
          <div class="relative ml-auto">
            <button (click)="toggleMenu()"
              class="flex items-center gap-2 pl-1 pr-3 py-1 rounded-full border border-gray-200 bg-white hover:border-amber-300 hover:shadow-md transition-all duration-200 group">
              <div class="w-7 h-7 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center flex-shrink-0">
                <span class="text-white text-[11px] font-bold leading-none">{{ userInitials }}</span>
              </div>
              <span class="text-sm font-semibold text-gray-700 group-hover:text-amber-600 max-w-[120px] truncate">{{ userName }}</span>
              <i class="pi pi-angle-down text-xs text-gray-400 group-hover:text-amber-500"></i>
            </button>

            @if (menuOpen) {
              <div class="absolute right-0 top-full mt-2 w-48 bg-white rounded-xl shadow-lg border border-gray-100 py-2 z-50">
                <div class="px-4 py-2 border-b border-gray-50">
                  <p class="text-xs text-gray-400 font-medium">Signed in as</p>
                  <p class="text-sm font-semibold text-gray-700 truncate">{{ userEmail }}</p>
                </div>
                <button (click)="signOut()" class="w-full px-4 py-2.5 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2 transition-colors">
                  <i class="pi pi-sign-out text-xs"></i>
                  Sign Out
                </button>
              </div>
            }
          </div>
        </div>
      </nav>
    </div><!-- end sticky wrapper -->

    @if (menuOpen) {
      <div class="fixed inset-0 z-40" (click)="menuOpen = false"></div>
    }
  `
})
export class NavigationComponent implements OnInit {
  private authService = inject(AuthService);
  private configService = inject(ConfigService);

  readonly menuToggle = output<void>();
  readonly navOpen = input(false);

  menuOpen = false;
  silverRate = 105;

  get userInitials(): string { return this.authService.getUserInitials(); }
  get userName(): string { return this.authService.getUserName(); }
  get userEmail(): string { return this.authService.getUserEmail(); }
  get isAdmin(): boolean { return this.authService.getUserRole() === 'Admin'; }

  ngOnInit() {
    this.configService.getRates().subscribe({
      next: rates => this.silverRate = rates.silverPerGram,
    });
    this.configService.silverRate.subscribe(rate => this.silverRate = rate);
  }

  toggleMenu() { this.menuOpen = !this.menuOpen; }

  signOut() {
    this.menuOpen = false;
    this.authService.logout().subscribe({ complete: () => this.authService.signOut() });
  }
}
